/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import { ButtonArray, MaximButton, BottomText, MiddleText } from './MaximButtonArray.style';
import Loading from '../Loading/Loading';
import { Card } from '../Card';
import { maxims, values } from './data';
import { Swoosh } from '../../assets/Swoosh';
import { Converse } from '../../assets/Converse';

/**
 * Maxim Button Array
 *
 * @name MaximButtonArray
 */

const nikeBlue = '#021A3B';
const nikeWhite = '#FFFFFF'


export const MaximButtonArray = ({ typeChooser, handleFormChange, maximType, maxim, handleLoading, isLoading }) => {
    const [list, setList] = useState(maxims);

    useEffect(() => {
        const vals = maximType === 'maxim' ? maxims : values;
        handleLoading();
        setList(vals);
    }, [maximType]);

    if (typeChooser) {
        return (
            <ButtonArray>
                <SwooshButton selected={maximType === 'maxim'} onClick={() => handleFormChange('maximType', 'maxim')} />
                <ConverseButton selected={maximType === 'value'} onClick={() => handleFormChange('maximType', 'value')} />
            </ButtonArray>
        );
    }
    return (
    <ButtonArray>
        {list.map((text, i) => (
            <TextButton
                key={i}
                text={text.title}
                behaviors={text.behaviors}
                isLoading={isLoading}
                selected={text.title === maxim}
                onClick={() => handleFormChange('maxim', text.title)} />
        ))}
    </ButtonArray>
    );
}

function TextButton(props) {
    const bgColor = props.selected ? nikeBlue : nikeWhite;
    const color = props.selected ? nikeWhite : nikeBlue;
    return (
        <Card
            title={props.text}
            behaviors={props.behaviors}
            onClick={props.onClick}
            backgroundColor={bgColor}
            textColor={color}
            isLoading={props.isLoading}
        />
        // <MaximButton style={{ backgroundColor: bgColor }} onClick={props.onClick}>
        //     {props.isLoading ? (
        //         <Loading pixelWidth={40} strokeColor={'#BBB'} />
        //     ) : (
        //         <MiddleText style={{ color }}>
        //             {props.text}
        //         </MiddleText>
        //     )}
        // </MaximButton>
    );
}

function SwooshButton(props) {
    const bgColor = props.selected ? nikeBlue : nikeWhite;
    const color = props.selected ? nikeWhite : nikeBlue;
    return (
        <MaximButton style={{ backgroundColor: bgColor }} onClick={props.onClick}>
            <Swoosh width='69px' height='24.34px' fill={color} />
            <BottomText style={{ color }}>
                Maxim
            </BottomText>
        </MaximButton>
    );
}

function ConverseButton(props) {
    const bgColor = props.selected ? nikeBlue : nikeWhite;
    const color = props.selected ? nikeWhite : nikeBlue;
    return ( 
        <MaximButton style={{ backgroundColor: bgColor }} onClick={props.onClick}>
            <Converse width='68.86px' height='58.12px' fill={color} />
            <p style={{
                color: color,
                marginTop: '30px',
                position: 'absolute',
                bottom: '12px',
                fontFamily: 'Helvetica Neue',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '18px',
                lineHeight: '24px'
            }}>Value</p>
        </MaximButton>
    );
}


// WEBPACK FOOTER //
// ./src/components/MaximButtonArray/MaximButtonArray.js